export enum CategoryTypeEnumDto {
    Association = "association",
    Confederation = "confederation",
    Cooperatives = "cooperatives",
    Delegations = "delegations",
    Federations = "federations",
    Foundation = "foundation",
    Groupings = "groupings",
}
